import { render, staticRenderFns } from "./incident-detail-dialog.vue?vue&type=template&id=72e49f1d&scoped=true&"
import script from "./incident-detail-dialog.vue?vue&type=script&lang=js&"
export * from "./incident-detail-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e49f1d",
  null
  
)

export default component.exports